const zeroPad = (num, numDigits = 2) => {
    let tmp = "" + num;
    while (tmp.length < numDigits) {
        tmp = "0" + tmp;
    }
    return tmp;
}
export const timestampCoarse = (time) => {
    const hours = time.getHours();
    const minutes = time.getMinutes();
    return `${zeroPad(hours % 12)}:${zeroPad(minutes)}`;
}

export const timestampFine = (time) => {
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();
    return `${zeroPad(hours % 12)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
}

export const timestampMeridiem = (time) => {
    return time.getHours() > 12 ? "PM": "AM";
}


// WEBPACK FOOTER //
// ./src/modules/format.js